// frontend/src/components/Results/TermanDetalle.js
// Desarrollo de resultados del Terman-Merrill: resumen, capacidades,
// fortalezas, áreas de oportunidad y detalle por serie. Los datos vienen de
// resultado.terman.interpretacion (backend/src/services/termanInterpretacion.js).

import React from 'react';

// Color por nivel; siempre va acompañado del texto del nivel
const COLOR_NIVEL = {
  'Alto': '#2F855A',
  'Medio alto': '#048377',
  'Medio': '#B7791F',
  'Bajo': '#DD6B20',
  'Muy bajo': '#C53030',
};

const Barra = ({ porcentaje, nivel }) => (
  <div className="terman-barra" aria-hidden="true">
    <div style={{ width: `${porcentaje}%`, background: COLOR_NIVEL[nivel] || '#048377' }} />
  </div>
);

const NivelBadge = ({ nivel }) => (
  <span className="terman-nivel" style={{ color: COLOR_NIVEL[nivel], borderColor: COLOR_NIVEL[nivel] }}>{nivel}</span>
);

const TermanDetalle = ({ interpretacion }) => {
  if (!interpretacion) return null;
  const { resumen, areas, fortalezas, areas_oportunidad: oportunidades, series, nota } = interpretacion;

  return (
    <div className="terman-detalle">
      <p className="terman-resumen">{resumen}</p>

      <h5>Capacidades</h5>
      <div className="terman-areas">
        {areas.map(a => (
          <div key={a.clave} className="terman-area">
            <div className="terman-fila">
              <span>{a.nombre} <small>(Series {a.series.join(', ')})</small></span>
              <span><strong>{a.porcentaje}%</strong> <NivelBadge nivel={a.nivel} /></span>
            </div>
            <Barra porcentaje={a.porcentaje} nivel={a.nivel} />
          </div>
        ))}
      </div>

      <div className="terman-fo">
        <div className="terman-fo-col terman-fortalezas">
          <h5>Fortalezas{interpretacion.fortalezas_relativas ? ' (resultados relativos)' : ''}</h5>
          {fortalezas.length === 0 ? <p className="terman-vacio">Sin fortalezas marcadas.</p> : (
            <ul>
              {fortalezas.map(f => (
                <li key={f.serie}>
                  <strong>{f.nombre} · {f.porcentaje}%</strong>
                  <span>{f.texto}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="terman-fo-col terman-oportunidades">
          <h5>Áreas de oportunidad{interpretacion.areas_oportunidad_relativas ? ' (resultados relativos)' : ''}</h5>
          {oportunidades.length === 0 ? <p className="terman-vacio">No presenta áreas de oportunidad marcadas.</p> : (
            <ul>
              {oportunidades.map(o => (
                <li key={o.serie}>
                  <strong>{o.nombre} · {o.porcentaje}%</strong>
                  <span>{o.texto}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <h5>Detalle por serie</h5>
      <div className="terman-tabla-wrap">
        <table className="terman-tabla">
          <thead>
            <tr>
              <th>Serie</th>
              <th>Qué mide</th>
              <th>Puntaje</th>
              <th>Logro</th>
              <th>Nivel</th>
            </tr>
          </thead>
          <tbody>
            {series.map(s => (
              <tr key={s.serie}>
                <td><strong>{s.serie}</strong> · {s.nombre}</td>
                <td className="terman-mide">{s.mide}</td>
                <td>{s.puntaje} / {s.maximo}<small>{s.aciertos} aciertos · {s.errores} errores</small></td>
                <td className="terman-logro"><span>{s.porcentaje}%</span><Barra porcentaje={s.porcentaje} nivel={s.nivel} /></td>
                <td><NivelBadge nivel={s.nivel} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="terman-nota">{nota}</p>
    </div>
  );
};

export default TermanDetalle;
